// React
import { useState } from 'react';

// Detail
export default function useDetail() {
  // Countries (cultures' data sources)
  const [countries, setCountries] = useState([]);

  // Cultures
  const [cultures, setCultures] = useState([]);

  // Save countries (cultures' data sources)
  const saveCulturesDataSource = (newCountries, countryId) => {
    setCountries(newCountries);

    if (countryId) {
      saveCultures(countryId, newCountries);
    }
  };

  // Save cultures
  const saveCultures = (countryId, newCountries = countries) => {
    const country = newCountries.find((country) => country.value === countryId);

    let newCultures = [];

    if (country) {
      newCultures = newCountries.find((country) => country.value === countryId)
        .cultures;
    }

    setCultures(newCultures);
  };

  return {
    cultures,
    saveCulturesDataSource: saveCulturesDataSource,
    saveCultures: saveCultures
  };
}
